export enum EntryCyclesRequestStatusAction {
  Load = '[EntryCycles] [Request Status] Load',
  Success = '[EntryCycles] [Request Status] Success',
  Error = '[EntryCycles] [Request Status] Error',
}
